//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UserLocation from "../lib/get-user-location";
import LocationPin from "../../images/icons/icon-location-pin--outline.svg";

export default {
  data: () => ({ searchAddress: "", message: false, }),
  components: {
    LocationPin
  },
  mounted() {
    let autocomplete = new gm.places.Autocomplete(this.$refs.searchInput);
    let pacOpen = false;

    if (window.Mardens && window.Mardens.locations) {
      this.message = window.Mardens.locations.content;
    }

    gm.event.addDomListener(this.$refs.searchInput, "keydown", function(event) {
      if (! pacOpen) {
        // autocomplete box isn't open.
        return;
      }

      if (event.keyCode === 13) {
        event.preventDefault();

        pacOpen = false;
      }

      window.jQuery(".pac-item").click(function() {
        pacOpen = false;
      });
    });

    autocomplete.addListener("place_changed", () => {
      let place = autocomplete.getPlace();

      pacOpen = true;

      if (! place.geometry) {
        return;
      }

      this.searchAddress = place.formatted_address;

      let geo = place.geometry.location;

      window.PubSub.publish('user:location', { lat: geo.lat(), lng: geo.lng() });
    });
  },

  methods: {
    searchLocations() {
      if (!this.searchAddress) {
        return;
      }

      // Fire "user:location" event once we get the Geocode response.
      let geocoder = new gm.Geocoder();

      geocoder.geocode(
        { address: this.searchAddress },
        this.geocodeAddress.bind(this)
      );
    },
    /**
     * Gets the user's location via the geolocation api.
     *
     * @see lib/get-user-location.js
     */
    getLocation() {
      UserLocation.query();
    },

    geocodeAddress(results, status) {
      if (status != "OK") {
        console.error("[Marden's] - Geocoding failed!");
      }

      let loc = results[0].geometry.location;

      window.PubSub.publish("user:location", { lat: loc.lat(), lng: loc.lng() });
    }
  }
};



// WEBPACK FOOTER //
// ./scripts/components/LocationSearch.vue